import { render, staticRenderFns } from "./RecommendedPeople.vue?vue&type=template&id=970cc466&lang=pug&"
import script from "./RecommendedPeople.vue?vue&type=script&lang=js&"
export * from "./RecommendedPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports